import { api } from '../../services/api'

const state = () => ({
  items: [],
  loading: false,
  error: null,
  submitLoading: false
})

const getters = {
  all: (s) => s.items
}

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items
  },
  REMOVE_ITEM(state, id) {
    state.items = state.items.filter((x) => String(x.id) !== String(id))
  },
  SET_LOADING(state, v) {
    state.loading = v
  },
  SET_ERROR(state, e) {
    state.error = e
  },
  SET_SUBMIT_LOADING(state, v) {
    state.submitLoading = v
  }
}

const actions = {
  async submit({ commit }, { name, number, message }) {
    commit('SET_SUBMIT_LOADING', true)
    try {
      const { data } = await api.post('user/contact', { name, number, message })
      return data
    } finally {
      commit('SET_SUBMIT_LOADING', false)
    }
  },

  async list({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await api.get('contact-messages')
      commit('SET_ITEMS', Array.isArray(data) ? data : data?.items || [])
      commit('SET_ERROR', null)
    } catch (e) {
      commit('SET_ERROR', e.response?.data?.error || e.message || 'Failed to load messages')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async remove({ commit }, id) {
    await api.delete(`contact-messages/${id}`)
    commit('REMOVE_ITEM', id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
